jQuery( function($) {

    if($('#annuaireMap').length > 0){

        var annuaireIcon = L.icon({
            iconUrl: '/wp-content/themes/kreenoot-child/assets/externals/map-marker-alt-solid.png',
            iconSize: [28, 42],
            iconAnchor: [16, 46],
            popupAnchor: [0, -50],
        });

        var annuaireMap = L.map('annuaireMap', { zoomControl: false }).setView([47.86960720748863, 1.837930398206025], 12);
        new L.Control.Zoom({ position: 'bottomright' }).addTo(annuaireMap); 

        var latlngs = [
            [47.82656631249147, 1.8312779653976148],
            [47.83601591217664, 1.820720790481759],
            [47.83872371194375, 1.8111077531600035],
            [47.83878132316938, 1.8111077531600035],
            [47.84261786741995, 1.8076781548809155],
            [47.841083283766345, 1.8191980875619544],
            [47.85695812758519, 1.80187421933169],
            [47.85908227334406, 1.8057435096978405],
            [47.860262316717844, 1.8045123718540652],
            [47.86309431122872, 1.8133062135953162],
            [47.86315330946924, 1.8098766153162282],
            [47.86480523294171, 1.8134820904301414],
            [47.86486422923494, 1.81972571806643],
            [47.868462876146886, 1.8315974044171188],
            [47.872297224940326, 1.8369616478792818],
            [47.870940487798826, 1.8534061319354218],
            [47.86834489168524, 1.8534061319354218],
            [47.868403883949625, 1.8498006568215088],
            [47.86480523294171, 1.8498885952389215],
            [47.86468724015379, 1.8519111788394094],
            [47.8508802298624, 1.8550769618662595],
            [47.849786115275585, 1.8536082611017335],
            [47.832633545486836, 1.8608377921941346],
            [47.8265256764623, 1.8311403757790268]
        ];

        var polyline = L.polyline(latlngs, {color: '#009EE0'}).addTo(annuaireMap);

        L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            maxZoom: 18,
            minZoom: 12,
            id: 'mapbox/streets-v11'
        }).addTo(annuaireMap);


        //Side Menu

        let timer = null;

        $('.inputSearch').on('keydown', function(){
            clearTimeout(timer); 
            timer = setTimeout(category_annuaire, 1000)
        });

        $('body').on('click', '.annuaireHide', function(){
            $('.annuaireCategory').toggleClass('hide');
            $(this).toggleClass('active');
        })

        $('body').on("click", 'li.categorySide', function(){
            $('.inputSearch').val('');
        });
        $('body').on("click", 'li.categorySide', category_annuaire);

    }
    
    function category_annuaire(){

        let category = $(this).data('value');
        let search = $('.inputSearch').val();

        $.ajax({
            url: kreenoot_child.ajax_url,
            type: 'POST',
            data: {
                action: "kl_annuaire",
                childValue: category,
                searchValue: search
            },
            beforeSend: function(){
                $('.annuaireCategory').empty('').html(`<p class="search-loading">Chargement...</p>`);
            },
            success: function(response){
                //console.log(response);
                $('.annuaireCategory').empty("").html(response);

                if( $('#annuaireMap').length > 0 ) {
                    // Suppression des markers actuels
                    annuaireMap.eachLayer(function(layer) {
                        if ("http://{s}.tile.osm.org/{z}/{x}/{y}.png" != layer._url){
                            annuaireMap.removeLayer(layer);
                        };
                    });

                    var polyline = L.polyline(latlngs, {color: '#009EE0'}).addTo(annuaireMap);

                    
                    let mapMarkers = document.querySelectorAll('.markerMap'),
                                i;

                    // Ajout des nouveaux markers
                    let newMarkers = L.markerClusterGroup();

                    if (mapMarkers.length > 0) {
                                
                        mapMarkers.forEach(marker => {
        
                            let latitude = parseFloat(marker.getAttribute('data-lat'));
                            let longitude = parseFloat(marker.getAttribute('data-long'));
                            let title = marker.getAttribute('data-title');
                            let address = marker.getAttribute('data-address');
                            let term = marker.getAttribute('data-term');
                            let img = marker.getAttribute('data-img');
                            let link = marker.getAttribute('data-link');

                            let html = '<div class="popupMap">';

                            html += '<div class="infos">';

                            if(title){
                                html += '<p class="title">' + title + '</p>';
                            }

                            if(term){
                                html += '<p class="term"><span>' + term + '</span></p>';
                            }

                            if(address){
                                html += '<p class="address"><svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" /></svg> <span>' + address + '</span></p>';
                            }

                            if(link){
                                html += '<p class="link"><a href="' + link + '"><span>Plus de détails</span> <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" /></svg></a></p>';
                            }

                            html += '</div>';

                            if(img){
                                html += '<div class="img"><img src="' + img + '"></div>';
                            }

                            html += '</div>';

                            if (latitude && longitude) {
                                let newMarker = L.marker([latitude, longitude], {icon: annuaireIcon});
                                newMarker.bindPopup(html);
                                newMarkers.addLayer(newMarker);

                                $(marker).on('click', function(){
                                    
                                    annuaireMap.setView([latitude, longitude], 17);
                                    newMarker.openPopup();
                                })
                            }

                        })

                        annuaireMap.addLayer(newMarkers);

                        if( newMarkers.getBounds() ) {
                            annuaireMap.fitBounds( newMarkers.getBounds(), {padding: [10, 10]} );
                        }
                    } 
                }

            },
            error: function(xhr, ajaxOptions, thrownError){
                console.error(xhr);
            }
        })
    }


});